import React from 'react'
import { PRODUCT_TYPES } from './Tabs'

const allowedCREColumns = ['50%', '55%', '60%', '65%']

const InterestTable = ({ interests, uniq, filtered, productType, discountValue, onClick }) => {
  return (
    <>
      <table className={!filtered ? 'min-w-full' : ''}>
        <thead>
          <tr className="border-b-2 border-primary-80 ">
            <th className="pr-6 py-3 whitespace-nowrap text-left">Rentevaste periode{productType === PRODUCT_TYPES.CLASSIQ && ' **'}</th>
            {interests.ltvs.map((val, key) => {
              if (productType === PRODUCT_TYPES.GENERIQ && !allowedCREColumns.includes(val.label)) {
                return null
              }

              return (
                <th
                  key={key}
                >
                  {'≤  ' + val?.label}
                  {(productType === PRODUCT_TYPES.BASIQ ||
                    productType === PRODUCT_TYPES.BASIQ_SELECT ||
                    productType === PRODUCT_TYPES.CLASSIQ ||
                    productType === PRODUCT_TYPES.CLASSIQ_SELECT) &&
                    '85%' === val.label &&
                    ' *'}
                </th>
              )
            })}
            {filtered && <th></th>}
          </tr>
        </thead>

        <tbody>
          {interests.rvps.map((val, interestKey) => {
            return (
              <tr
                key={interestKey}
                className="hover:bg-primary-80 border-b border-primary-80 "
              >
                <td className="pr-6 py-3 whitespace-nowrap font-bold">
                  {val.label}
                  {'1 maand' === val.label &&
                    (productType === PRODUCT_TYPES.BASIQ || productType === PRODUCT_TYPES.GENERIQ) &&
                    ' **'}
                </td>
                {val.interests.map((interestItem, key) => {
                  const shouldApplyDiscount = !val.label.toLowerCase().includes('maand')
                  const interestValue = (uniq ? interestItem.value + 0.2 : interestItem.value) - (shouldApplyDiscount ? discountValue : 0)

                  if (filtered && interests.ltvs?.length > 0) {
                    let getIntValue = 0
                    interests.interests.forEach((newIntItem) => {
                      console.log('newIntItem', newIntItem, val.id)
                      if (newIntItem.ltvId === interests.ltvs[0].id && newIntItem.rvpId === val.id) {
                        getIntValue = newIntItem.value - (shouldApplyDiscount ? discountValue : 0)
                        if (uniq) {
                          getIntValue = getIntValue + 0.2 // TODO Get source data
                        }
                      }
                    })

                    if (productType === PRODUCT_TYPES.GENERIQ && !allowedCREColumns.includes(interests.ltvs[key].label)) {
                      return null
                    }

                    return (
                      <>
                        <td
                          key={key}
                          className={`px-6 py-3 whitespace-nowrap text-right font-medium`}
                        >
                          {productType !== PRODUCT_TYPES.BASIQ &&
                            productType !== PRODUCT_TYPES.CLASSIQ &&
                            getIntValue.toLocaleString('nl', {
                              minimumFractionDigits: 2,
                            }) + '%'}
                          {(productType === PRODUCT_TYPES.BASIQ || productType === PRODUCT_TYPES.CLASSIQ) &&
                            getIntValue.toLocaleString('nl', {
                              minimumFractionDigits: 2,
                            }) + '%'}
                        </td>
                        <td>
                          <button
                            type="button"
                            onClick={() => onClick({ interestItem, interestKey, interestValue, val })}
                            className="focus:outline-none  py-1 px-5 shadow-sm text-center text-white bg-secondary-100 hover:bg-primary-300 font-medium disabled:opacity-50 disabled:hover:bg-primary-100"
                          >
                            Aanvragen
                          </button>
                        </td>
                      </>
                    )
                  } else if (key < interests.ltvs.length) {
                    if (productType === PRODUCT_TYPES.GENERIQ && !allowedCREColumns.includes(interests.ltvs[key].label)) {
                      return null
                    }

                    return (
                      <td
                        key={key}
                        className={`px-6 py-3 whitespace-nowrap text-right font-medium`}
                      >
                        {productType !== PRODUCT_TYPES.BASIQ &&
                          productType !== PRODUCT_TYPES.CLASSIQ &&
                          interestValue.toLocaleString('nl', {
                            minimumFractionDigits: 2,
                          }) + '%'}
                        {(productType === PRODUCT_TYPES.BASIQ || productType === PRODUCT_TYPES.CLASSIQ) &&
                          interestValue.toLocaleString('nl', {
                            minimumFractionDigits: 2,
                          }) + '%'}
                      </td>
                    )
                  }
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {(productType === PRODUCT_TYPES.BASIQ ||
        productType === PRODUCT_TYPES.BASIQ_SELECT ||
        productType === PRODUCT_TYPES.CLASSIQ ||
        productType === PRODUCT_TYPES.CLASSIQ_SELECT) && (
        <div className="mt-2 text-sm">
          *De tarieven &lt; 85% gelden alleen voor bestaande financieringen met een LTV &gt; 80%
        </div>
      )}
      {(productType === PRODUCT_TYPES.BASIQ || productType === PRODUCT_TYPES.GENERIQ) && (
        <div className="mt-4 text-sm">
          **Bij een variabele rente zijn 0,25% afsluitkosten van toepassing
        </div>
      )}
      {productType === PRODUCT_TYPES.GENERIQ && (
        <div className="mt-4 text-sm">
          De rentes voor een SpecifiQ hypotheek kunnen afwijken van de hierboven genoemde tarieven en zijn afhankelijk
          van de situatie en onderpand.
        </div>
      )}
      {productType === PRODUCT_TYPES.CLASSIQ && (
        <>
          <div className="mt-4 text-sm">
            **Bij de ClassiQ handelsfinanciering dient de keuze 1 maand, 1 jaar of 2 jaar te zijn.
          </div>
          <div className="mt-4 text-sm">
            Bij de ClassiQ hypotheek zijn 0,75% afsluitkosten van toepassing.
          </div>
        </>
      )}
      {(productType === PRODUCT_TYPES.BASIQ_SELECT || productType === PRODUCT_TYPES.CLASSIQ_SELECT) && (
        <>
          <div className="mt-4 text-sm">
            Voor combinatiepanden waarbij het commerci&euml;le deel &gt;20% van de totale marktwaarde bedraagt, geldt
            een rente-opslag van 0,20%.
          </div>
          <div className="mt-4 text-sm">
            Rentekorting bij een lidmaatschap van Vastgoedbelang is niet mogelijk i.c.m. een{' '}
            {productType === PRODUCT_TYPES.BASIQ_SELECT ? 'BasiQ' : 'ClassiQ'} Select rente.
          </div>
        </>
      )}
      {productType === PRODUCT_TYPES.CLASSIQ_SELECT && (
        <>
          <div className="mt-4 text-sm">
            Bij de ClassiQ Select handelsfinanciering dient de keuze 1 maand, 1 jaar of 2 jaar te zijn.
          </div>
          <div className="mt-4 text-sm">
            Bij de ClassiQ Select hypotheek zijn 0,75% afsluitkosten van toepassing.
          </div>
        </>
      )}
    </>
  )
}

export default InterestTable
